<template>
  <div>
    <div style="padding-left: 13px">
      <v-container fluid grid-list-lg>
        <message :messages="messages"></message>
        <v-layout row wrap>
          <v-flex xs6 md4 lg4>
            <v-subheader class="queryLabel">{{ labels.propNo }}</v-subheader>
            <span class="queryValue">{{ propInfo.propNo }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode && !convertMode">
            <v-subheader class="queryLabel">{{ labels.polNo1 }}</v-subheader>
            <span class="queryValue">{{ propInfo.polNo1 }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else-if="convertMode">
            <v-autocomplete
              :items="propPlanList"
              v-model="form.propPlan"
              :label="labels.planNo"
              item-text="label"
              item-value="value"
              data-vv-name="planNo"
              :data-vv-as="labels.planNo"
              :error-messages="errors.collect('planNo')"
              clearable
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <v-autocomplete
              :items="propPlanList"
              v-model="form.propPlan"
              :label="labels.planNo"
              item-text="label"
              item-value="value"
              data-vv-name="planNo"
              :data-vv-as="labels.planNo"
              :error-messages="errors.collect('planNo')"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode && !convertMode">
            <v-subheader class="queryLabel">{{ labels.polNo2 }}</v-subheader>
            <span class="queryValue">{{ propInfo.polNo2 }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else></v-flex>
          <v-flex xs6 md2 lg2>
            <v-subheader class="queryLabel">{{ labels.ipcNo }}</v-subheader>
            <span class="queryValue">{{ propInfo.ipcNo }}</span>
          </v-flex>
          <v-flex xs6 md2 lg2>
            <v-subheader class="queryLabel">{{ labels.ipcSeqNo }}</v-subheader>
            <span class="queryValue">{{ propInfo.ipcSeqNoval }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.propDate }}</v-subheader>
            <span class="queryValue">{{ this.formatDate(propInfo.propDate) }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <cal-picker
              v-model="form.propDate"
              :label="labels.propDate"
              :data-vv-as="labels.propDate"
              data-vv-name="propDate"
              :error-messages="errors.collect('propDate')"
              v-validate="'required'"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.propStat }}</v-subheader>
            <span class="queryValue">{{ propInfo.propStat }} - {{ propInfo.propStatDesc }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <v-autocomplete
              :items="propStatList"
              v-model="form.propStat"
              :label="labels.propStat"
              item-text="label"
              item-value="value"
              data-vv-name="propStat"
              :data-vv-as="labels.propStat"
              :error-messages="errors.collect('propStat')"
              v-validate="'required'"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
            <span class="queryValue">{{ propInfo.polType }} - {{ propInfo.polTypeDesc }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
            <span class="queryValue">{{ propInfo.scheme }} - {{ propInfo.schbusClsDesc }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="propInfo.planNo !== undefined && queryMode">
            <v-subheader class="queryLabel">{{ labels.planNo }}</v-subheader>
            <span class="queryValue">{{ propInfo.planNo }} - {{ propInfo.planDesc }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
            <span class="queryValue">{{ this.formatDate(propInfo.comDate) }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <cal-picker
              v-model="form.comDate"
              :label="labels.comDate"
              :data-vv-as="labels.comDate"
              data-vv-name="comDate"
              :error-messages="errors.collect('comDate')"
              v-validate="comDateValidation"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
            <span class="queryValue">{{ this.formatDate(propInfo.expDate) }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <v-text-field
              v-num-mask
              v-model="form.grossAnnPrem"
              :label="labels.grossAnnPrem"
              :error-messages="errors.collect('grossAnnPrem')"
              data-vv-name="grossAnnPrem"
              :data-vv-as="labels.grossAnnPrem"
              v-validate="'mask_decimal:2|mask_min_value:0.00|mask_max_value:999999999999999999.99'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.freeInsFr }}</v-subheader>
            <span class="queryValue">{{ this.formatDate(propInfo.freeInsFr) }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <cal-picker
              v-model="form.freeInsFr"
              :label="labels.freeInsFr"
              :data-vv-as="labels.freeInsFr"
              data-vv-name="freeInsFr"
              :error-messages="errors.collect('freeInsFr')"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 md4 lg4 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.freeInsTo }}</v-subheader>
            <span class="queryValue">{{ this.formatDate(propInfo.freeInsTo) }}</span>
          </v-flex>
          <v-flex xs6 md4 lg4 v-else>
            <cal-picker
              v-model="form.freeInsTo"
              :label="labels.freeInsTo"
              :data-vv-as="labels.freeInsTo"
              data-vv-name="freeInsTo"
              :error-messages="errors.collect('freeInsTo')"
              v-validate="feeInsToValidation"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 md4 lg4>
            <v-checkbox
              v-model="propInfo.hdbReplCost"
              :label="labels.hdbReplCost"
              data-vv-name="hdbReplCost"
              :data-vv-as="labels.hdbReplCost"
              :error-messages="errors.collect('hdbReplCost')"
              :disabled="true"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md12 lg12 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.freeInsRem }}</v-subheader>
            <span class="queryValue">{{ propInfo.freeInsRem }}</span>
          </v-flex>
          <v-flex xs12 md12 lg12 v-else>
            <v-text-field
              :label="labels.freeInsRem"
              v-model="form.freeInsRem"
              :error-messages="errors.collect('freeInsRem')"
              v-validate="'max:50'"
              data-vv-name="freeInsRem"
              :data-vv-as="labels.freeInsRem"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12 lg12 v-if="queryMode">
            <v-subheader class="queryLabel">{{ labels.comments }}</v-subheader>
            <span class="queryValue">{{ propInfo.comment1 }}</span>
            <span class="queryValue">{{ propInfo.comment2 }}</span>
          </v-flex>
          <v-flex xs12 md12 lg12 v-else>
            <v-text-field
              :label="labels.comment1"
              v-model="form.comment1"
              :error-messages="errors.collect('comment1')"
              v-validate="'max:50'"
              data-vv-name="comment1"
              :data-vv-as="labels.comment1"
            ></v-text-field>
            <v-text-field
              :label="labels.comment2"
              v-model="form.comment2"
              :error-messages="errors.collect('comment2')"
              v-validate="'max:50'"
              data-vv-name="comment2"
              :data-vv-as="labels.comment2"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-spacer class="mt-2"></v-spacer>
    <!-- Proposer Details -->
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-account-multiple</v-icon><span class="headerTitle">{{ labels.proposerTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.name1 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.name1 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.name1"
                      v-model="form.name1"
                      :error-messages="errors.collect('name1')"
                      v-validate="'required|max:50'"
                      data-vv-name="name1"
                      :data-vv-as="labels.name1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.name2 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.name2 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.name2"
                      v-model="form.name2"
                      :error-messages="errors.collect('name2')"
                      v-validate="'max:50'"
                      data-vv-name="name2"
                      :data-vv-as="labels.name2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.name3 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.name3 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.name3"
                      v-model="form.name3"
                      :error-messages="errors.collect('name3')"
                      v-validate="'max:50'"
                      data-vv-name="name3"
                      :data-vv-as="labels.name3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.addr1 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.addr1 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.addr1"
                      v-model="form.addr1"
                      :error-messages="errors.collect('addr1')"
                      v-validate="'required|max:50'"
                      data-vv-name="addr1"
                      :data-vv-as="labels.addr1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.addr2 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.addr2 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.addr2"
                      v-model="form.addr2"
                      :error-messages="errors.collect('addr2')"
                      v-validate="'max:50'"
                      data-vv-name="addr2"
                      :data-vv-as="labels.addr2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.addr3 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.addr3 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.addr3"
                      v-model="form.addr3"
                      :error-messages="errors.collect('addr3')"
                      v-validate="'max:50'"
                      data-vv-name="addr3"
                      :data-vv-as="labels.addr3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.addr4 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.addr4 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.addr4"
                      v-model="form.addr4"
                      :error-messages="errors.collect('addr4')"
                      v-validate="'max:50'"
                      data-vv-name="addr4"
                      :data-vv-as="labels.addr4"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
                    <span class="queryValue">{{ propInfo.postCode }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.postCode"
                      v-model="form.postCode"
                      :error-messages="errors.collect('postCode')"
                      v-validate="'max:9'"
                      data-vv-name="postCode"
                      :data-vv-as="labels.postCode"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 lg4></v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.telNo }}</v-subheader>
                    <span class="queryValue">{{ propInfo.telNo }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.telNo"
                      v-model="form.telNo"
                      :error-messages="errors.collect('telNo')"
                      v-validate="'max:30'"
                      data-vv-name="telNo"
                      :data-vv-as="labels.telNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.mobileNo }}</v-subheader>
                    <span class="queryValue">{{ propInfo.mobileNo }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.mobileNo"
                      v-model="form.mobileNo"
                      :error-messages="errors.collect('mobileNo')"
                      v-validate="'max:30'"
                      data-vv-name="mobileNo"
                      :data-vv-as="labels.mobileNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.faxNo }}</v-subheader>
                    <span class="queryValue">{{ propInfo.faxNo }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.faxNo"
                      v-model="form.faxNo"
                      :error-messages="errors.collect('faxNo')"
                      v-validate="'max:30'"
                      data-vv-name="faxNo"
                      :data-vv-as="labels.faxNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.email }}</v-subheader>
                    <span class="queryValue">{{ propInfo.email }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.email"
                      v-model="form.email"
                      :error-messages="errors.collect('email')"
                      v-validate="'max:40'"
                      data-vv-name="email"
                      :data-vv-as="labels.email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Payment Details -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-credit-card</v-icon><span class="headerTitle">{{ labels.paymentTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.acctName1 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.acctName1 }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.acctName1"
                      v-model="form.acctName1"
                      :error-messages="errors.collect('acctName1')"
                      v-validate="acctName1Validation"
                      data-vv-name="acctName1"
                      :data-vv-as="labels.acctName1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.acctName2 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.acctName2 }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.acctName2"
                      v-model="form.acctName2"
                      :error-messages="errors.collect('acctName2')"
                      data-vv-name="acctName2"
                      :data-vv-as="labels.acctName2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.paytMeth }}</v-subheader>
                    <span class="queryValue">{{ propInfo.paytMeth }} - {{ propInfo.paytMethDesc }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-autocomplete
                      :items="paytMethList"
                      v-model="form.paytMeth"
                      :label="labels.paytMeth"
                      item-text="label"
                      item-value="value"
                      data-vv-name="paytMeth"
                      :data-vv-as="labels.paytMeth"
                      :error-messages="errors.collect('paytMeth')"
                      v-validate="paytMethValidation"
                      @input="getCapCrcdGiro"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.crCdGIRO }}</v-subheader>
                    <span class="queryValue">{{ propInfo.crCdGIRO }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.crCdGIRO"
                      v-model="form.crCdGIRO"
                      :error-messages="errors.collect('crCdGIRO')"
                      v-validate="crCdGIROValidation"
                      data-vv-name="crCdGIRO"
                      :data-vv-as="labels.crCdGIRO"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Risk Details -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-home-modern</v-icon><span class="headerTitle">{{ labels.riskTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md12 lg12 v-if="propInfo.propType === 'FI'">
                    <div class="subheading">{{ labels.propTypeFI }}</div>
                  </v-flex>
                  <v-flex xs12 md12 lg12 v-else>
                    <v-subheader class="queryLabel">{{ labels.propTypeMA }}</v-subheader>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.loc1 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.loc1 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.loc1"
                      v-model="form.loc1"
                      :error-messages="errors.collect('form.loc1')"
                      v-validate="'required|max:50'"
                      data-vv-name="form.loc1"
                      :data-vv-as="labels.loc1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.loc2 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.loc2 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.loc2"
                      v-model="form.loc2"
                      :error-messages="errors.collect('loc2')"
                      data-vv-name="loc2"
                      :data-vv-as="labels.loc2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.loc3 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.loc3 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.loc3"
                      v-model="form.loc3"
                      :error-messages="errors.collect('loc3')"
                      data-vv-name="loc3"
                      :data-vv-as="labels.loc3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.loc4 }}</v-subheader>
                    <span class="queryValue">{{ propInfo.loc4 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.loc4"
                      v-model="form.loc4"
                      :error-messages="errors.collect('loc4')"
                      data-vv-name="loc4"
                      :data-vv-as="labels.loc4"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.locPostCode }}</v-subheader>
                    <span class="queryValue">{{ propInfo.locPostCode }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.locPostCode"
                      v-model="form.locPostCode"
                      :error-messages="errors.collect('locPostCode')"
                      data-vv-name="locPostCode"
                      :data-vv-as="labels.locPostCode"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="propInfo.propType === 'FI'"></v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode && propInfo.propType === 'FI'">
                    <v-subheader class="queryLabel">{{ labels.typeProp }}</v-subheader>
                    <span class="queryValue">{{ propInfo.typeProp }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="reviewMode && propInfo.propType === 'FI'">
                    <v-text-field
                      :label="labels.typeProp"
                      v-model="form.typeProp"
                      :error-messages="errors.collect('typeProp')"
                      v-validate="'required|max:30'"
                      data-vv-name="typeProp"
                      :data-vv-as="labels.typeProp"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode && propInfo.propType === 'FI'">
                    <v-subheader class="queryLabel">{{ labels.occpClass }}</v-subheader>
                    <span class="queryValue">{{ propInfo.occpClass }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="reviewMode && propInfo.propType === 'FI'">
                    <v-text-field
                      :label="labels.occpClass"
                      v-model="form.occpClass"
                      :error-messages="errors.collect('occpClass')"
                      v-validate="'required|max:40'"
                      data-vv-name="occpClass"
                      :data-vv-as="labels.occpClass"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="propInfo.propType === 'FI'"></v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode && propInfo.propType === 'FI'">
                    <v-subheader class="queryLabel">{{ labels.area }}</v-subheader>
                    <span class="queryValue">{{ propInfo.area }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="reviewMode && propInfo.propType === 'FI'">
                    <v-text-field
                      :label="labels.area"
                      v-model="form.area"
                      :error-messages="errors.collect('area')"
                      v-validate="'required|max:20'"
                      data-vv-name="area"
                      :data-vv-as="labels.area"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode && propInfo.propType === 'FI'">
                    <v-subheader class="queryLabel">{{ labels.gdsManuf }}</v-subheader>
                    <span class="queryValue">{{ propInfo.gdsManuf }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="reviewMode && propInfo.propType === 'FI'">
                    <v-text-field
                      :label="labels.gdsManuf"
                      v-model="form.gdsManuf"
                      :error-messages="errors.collect('gdsManuf')"
                      v-validate="'max:40'"
                      data-vv-name="gdsManuf"
                      :data-vv-as="labels.gdsManuf"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Financial Institution -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-cash-multiple</v-icon><span class="headerTitle">{{ labels.financialTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.fininst }}</v-subheader>
                    <span class="queryValue">{{ propInfo.fininst }} - {{ propInfo.abbrevName }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-autocomplete
                      :items="interList"
                      v-model="form.fininst"
                      :label="labels.fininst"
                      item-text="label"
                      item-value="value"
                      data-vv-name="fininst"
                      :data-vv-as="labels.fininst"
                      :error-messages="errors.collect('fininst')"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.finBrn }}</v-subheader>
                    <span class="queryValue">{{ propInfo.finBrn }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.finBrn"
                      v-model="form.finBrn"
                      :error-messages="errors.collect('finBrn')"
                      v-validate="finBrnValidation"
                      data-vv-name="finBrn"
                      :data-vv-as="labels.finBrn"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.finConPer }}</v-subheader>
                    <span class="queryValue">{{ propInfo.finConPer }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.finConPer"
                      v-model="form.finConPer"
                      :error-messages="errors.collect('finConPer')"
                      v-validate="finConPerValidation"
                      data-vv-name="finConPer"
                      :data-vv-as="labels.finConPer"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.finTelNo }}</v-subheader>
                    <span class="queryValue">{{ propInfo.finTelNo }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.finTelNo"
                      v-model="form.finTelNo"
                      :error-messages="errors.collect('finTelNo')"
                      v-validate="'max:30'"
                      data-vv-name="finTelNo"
                      :data-vv-as="labels.finTelNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.finFaxNo }}</v-subheader>
                    <span class="queryValue">{{ propInfo.finFaxNo }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.finFaxNo"
                      v-model="form.finFaxNo"
                      :error-messages="errors.collect('finFaxNo')"
                      v-validate="'max:30'"
                      data-vv-name="finFaxNo"
                      :data-vv-as="labels.finFaxNo"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-btn class="mt-2 mr-2" color="error" dark @click.prevent="doExit">
      {{ labels.exit }}
      <v-icon dark right>mdi-exit-to-app</v-icon>
    </v-btn>
    <v-btn v-if="reviewMode" color="primary" dark class="mt-2 mr-2" @click="doProceed" :loading="submitting">
      {{ labels.save }}
      <v-icon right>mdi-content-save</v-icon>
    </v-btn>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import isAfter from 'date-fns/isAfter'
import differenceInDays from 'date-fns/differenceInDays'
export default {
  data() {
    return {
      labels: {
        propNo: 'Proposal No.',
        polNo1: 'Policy Number (1)',
        polNo2: 'Policy Number (2)',
        ipcNo: 'IPC No.',
        ipcSeqNo: 'Sequence No.',
        propDate: 'Proposal Date',
        propStat: 'Proposal Status',
        polType: 'Policy Type',
        scheme: 'Scheme / Business Class',
        planNo: 'Plan',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        grossAnnPrem: 'Annual Premium (Before GST)',
        freeInsFr: 'Free Insurance Period From',
        freeInsTo: 'Free Insurance Period To',
        hdbReplCost: 'HDB Replacement Cost',
        freeInsRem: 'Free Insurance For',
        comments: 'Comments',
        proposerTitle: 'Proposer Details',
        name1: 'Name 1',
        name2: 'Name 2',
        name3: 'Name 3',
        addr1: 'Address 1',
        addr2: 'Address 2',
        addr3: 'Address 3',
        addr4: 'Address 4',
        loc1: 'Address 1',
        loc2: 'Address 2',
        loc3: 'Address 3',
        loc4: 'Address 4',
        postCode: 'Postal Code',
        locPostCode: 'Postal Code',
        telNo: 'Telephone No.',
        mobileNo: 'H/P No.',
        faxNo: 'Fax No.',
        email: 'Email',
        paymentTitle: 'Payment Details',
        acctName1: 'Account Holder Name 1',
        acctName2: 'Account Holder Name 2',
        paytMeth: 'Payment Method',
        crCdGIRO: 'Credit Card / GIRO No.',
        riskTitle: 'Risk Details',
        propTypeFI: 'Address of Property',
        propTypeMA: 'Address of Situation',
        typeProp: 'Type of Property',
        occpClass: 'Occupied As',
        area: 'Build in Area',
        gdsManuf: 'Goods Manufactured / Stored',
        financialTitle: 'Financial Institution',
        fininst: 'Finance Company',
        finBrn: 'Branch',
        finConPer: 'Contact Person',
        finTelNo: 'Telephone No.',
        finFaxNo: 'Fax No.',
        exit: 'Exit',
        save: 'Save',
        comment1: 'Comment 1',
        comment2: 'Comment 2'
      },
      form: {
        propNo: '',
        ipcNo: '',
        ipcSeqNo: '',
        propPlan: '',
        polType: '',
        scheme: '',
        planNo: '',
        propDate: '',
        propStat: '',
        comDate: '',
        expDate: '',
        grossAnnPrem: 0,
        freeInsFr: '',
        freeInsTo: '',
        freeInsRem: '',
        comment1: '',
        comment2: '',
        name1: '',
        name2: '',
        name3: '',
        addr1: '',
        addr2: '',
        addr3: '',
        addr4: '',
        postCode: '',
        telNo: '',
        mobileNo: '',
        faxNo: '',
        email: '',
        acctName1: '',
        acctName2: '',
        paytMeth: '',
        crCdGIRO: '',
        loc1: '',
        loc2: '',
        loc3: '',
        loc4: '',
        locPostCode: '',
        typeProp: '',
        occpClass: '',
        area: '',
        gdsManuf: '',
        fininst: '',
        finBrn: '',
        finConPer: '',
        finTelNo: '',
        finFaxNo: ''
      },
      propPlanList: [],
      propStatList: [],
      paytMethList: [],
      interList: [],
      capCrcdGiro: '',
      reviewMode: false,
      queryMode: false,
      submitting: false,
      isExpMoreThanComDate: false,
      convertMode: false
    }
  },
  methods: {
    doExit() {
      window.history.back()
    },
    async getPropPlanList() {
      const apiURI = this.menu.getPropPlanList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            propType: this.propInfo.propType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.propPlanList = []
          if (data) {
            data.map((propPlan) => {
              const convertList = {
                value: propPlan.value,
                label: propPlan.label
              }
              this.propPlanList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getPropStatList() {
      const apiURI = this.menu.getPropStatList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.propStatList = []
          if (data) {
            data.map((propStat) => {
              const convertList = {
                value: propStat.value,
                label: propStat.label
              }
              this.propStatList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getPaytMethList() {
      const apiURI = this.menu.getPaytMethList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.paytMethList = []
          if (data) {
            data.map((paytMeth) => {
              const convertList = {
                value: paytMeth.value,
                label: paytMeth.label
              }
              this.paytMethList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getCapCrcdGiro() {
      const apiURI = this.menu.getCapCrcdGiro
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            paytMeth: this.form.paytMeth
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.capCrcdGiro = ''
          if (data) {
            this.capCrcdGiro = data.capCrcdGiro
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getInterList() {
      const apiURI = this.menu.getInterList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.interList = []
          if (data) {
            data.map((inter) => {
              const convertList = {
                value: inter.value,
                label: inter.label
              }
              this.interList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    assignFormData() {
      this.form.propNo = this.propInfo.propNo
      this.form.ipcNo = this.propInfo.ipcNo
      this.form.ipcSeqNo = this.propInfo.ipcSeqNo
      this.form.propPlan = this.propInfo.polType + ',' + this.propInfo.scheme + ',' + this.propInfo.planNo
      this.form.propDate = this.propInfo.propDate
      this.form.propStat = this.propInfo.propStat
      this.form.comDate = this.propInfo.comDate
      this.form.expDate = this.propInfo.expDate
      this.form.grossAnnPrem = this.propInfo.grossAnnPrem
      this.form.freeInsFr = this.propInfo.freeInsFr
      this.form.freeInsTo = this.propInfo.freeInsTo
      this.form.freeInsRem = this.propInfo.freeInsRem
      this.form.comment1 = this.propInfo.comment1
      this.form.comment2 = this.propInfo.comment2
      this.form.name1 = this.propInfo.name1
      this.form.name2 = this.propInfo.name2
      this.form.name3 = this.propInfo.name3
      this.form.addr1 = this.propInfo.addr1
      this.form.addr2 = this.propInfo.addr2
      this.form.addr3 = this.propInfo.addr3
      this.form.addr4 = this.propInfo.addr4
      this.form.postCode = this.propInfo.postCode
      this.form.telNo = this.propInfo.telNo
      this.form.mobileNo = this.propInfo.mobileNo
      this.form.faxNo = this.propInfo.faxNo
      this.form.email = this.propInfo.email
      this.form.acctName1 = this.propInfo.acctName1
      this.form.acctName2 = this.propInfo.acctName2
      this.form.paytMeth = this.propInfo.paytMeth
      this.form.crCdGIRO = this.propInfo.crCdGIRO
      this.form.loc1 = this.propInfo.loc1
      this.form.loc2 = this.propInfo.loc2
      this.form.loc3 = this.propInfo.loc3
      this.form.loc4 = this.propInfo.loc4
      this.form.locPostCode = this.propInfo.locPostCode
      this.form.typeProp = this.propInfo.typeProp
      this.form.occpClass = this.propInfo.occpClass
      this.form.area = this.propInfo.area
      this.form.gdsManuf = this.propInfo.gdsManuf
      this.form.fininst = this.propInfo.fininst
      this.form.finBrn = this.propInfo.finBrn
      this.form.finConPer = this.propInfo.finConPer
      this.form.finTelNo = this.propInfo.finTelNo
      this.form.finFaxNo = this.propInfo.finFaxNo
    },
    async doProceed() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSave()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSave() {
      const apiURI = this.menu.savePropMaster
      if (apiURI) {
        this.submitting = true
        try {
          let massageForm = clone(this.form)
          if (massageForm.propPlan) {
            let propPlan = massageForm.propPlan.split(',')
            massageForm.polType = propPlan[0]
            massageForm.scheme = propPlan[1]
            massageForm.planNo = propPlan[2]
          }
          const result = await this.$http.put(apiURI, massageForm)
          const { data } = result
          if (data) {
            this.notify(data)
            // this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'propListing' })
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    }
  },
  computed: {
    propInfo() {
      return this.$store.state.proposal.proposalDetails.propInfo
    },
    propMode() {
      return this.$store.state.proposal.proposalMode
    },
    menu() {
      return this.$store.state.proposal.proposalDetails.menu
    },
    comDateValidation() {
      return 'required|valComDate:' + this.form.comDate
    },
    expDateValidation() {
      return 'required|valExpDate:' + this.form.expDate + this.form.comDate
    },
    feeInsToValidation() {
      return 'valFreeInsTo:' + this.form.freeInsTo + this.form.freeInsFr
    },
    acctName1Validation() {
      if (this.form.paytMeth !== undefined) {
        return 'required|max:40'
      } else {
        return null
      }
    },
    paytMethValidation() {
      if (this.form.paytMeth === undefined && (this.form.crCdGIRO === '' || this.form.crCdGIRO === undefined)) {
        return null
      } else {
        return 'required'
      }
    },
    crCdGIROValidation() {
      if (this.capCrcdGiro === 'CARD' || this.capCrcdGiro === 'GIRO') {
        return 'required|max:20'
      } else {
        return null
      }
    },
    finBrnValidation() {
      if (this.form.fininst !== undefined) {
        return 'required|max:30'
      } else {
        return null
      }
    },
    finConPerValidation() {
      if (this.form.fininst !== undefined) {
        return 'required|max:30'
      } else {
        return null
      }
    }
  },
  created() {
    this.$validator.extend('valComDate', {
      getMessage(field, args) {
        return 'This is more than 180 days earlier than Today'
      },
      validate(value, args) {
        if (value) {
          var comDate = args[0]
          let noDays = Math.abs(differenceInDays(removeTime(comDate), removeTime(new Date()))) + 1
          if (noDays > 180) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })

    this.$validator.extend('valExpDate', {
      getMessage(field, args) {
        return 'Expiry Date cannot be earlier than Commencement Date'
      },
      validate(value, args) {
        if (value) {
          let dates = args[0]
          let expDate = dates.slice(0, dates.indexOf(')') + 1)
          let comDate = dates.substring(59)
          if (isAfter(removeTime(comDate), removeTime(expDate))) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })

    this.$validator.extend('valFreeInsTo', {
      getMessage(field, args) {
        return 'Free Insurance Period To cannot be earlier than Free Insurance Period From'
      },
      validate(value, args) {
        if (value) {
          let dates = args[0]
          let freeInsTo = dates.slice(0, dates.indexOf(')') + 1)
          let freeInsFr = dates.substring(59)
          if (isAfter(removeTime(freeInsFr), removeTime(freeInsTo))) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })
  },
  beforeMount() {
    var tmpsq = this.propInfo.ipcSeqNo.toString()
    var tmpsqval = tmpsq
    if (tmpsq.length < 5) {
      for (var x = 5; x > tmpsq.length; x--) {
        tmpsqval = '0' + tmpsqval
      }
      this.propInfo.ipcSeqNoval = tmpsqval
    }
    if (this.propMode === 'Review') {
      this.reviewMode = true
      this.queryMode = false
      this.assignFormData()
      this.getPropPlanList()
      this.getPropStatList()
      this.getPaytMethList()
      this.getInterList()
      this.getCapCrcdGiro()
    } else {
      this.reviewMode = false
      this.queryMode = true

      if (this.propMode === 'Convert') {
        this.convertMode = true
        this.getPropPlanList()
        this.form.propPlan = this.propInfo.polType + ',' + this.propInfo.scheme + ',' + this.propInfo.planNo
      } else {
        this.convertMode = false
      }
    }
  },
  mixins: [MessageMixin]
}
</script>
